let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("7uPiT")).then(() => parcelRequire('hHM7Q'));